<template>
  <div v-if="userHasPermission(constants.PERMISSION_TYPES.DROP_COST, constants.PERMISSION_VALUES.VIEW)">
    <message-modal />
    <div>
      <main-header />
      <parcel-filter filter-name="drop-cost" />
      <div class="spl-drop-cost-table__excel">
        <form-button @onClick="exportToExcel">
          Excel
        </form-button>
      </div>
      <div class="spl-drop-cost-table">
        <table>
          <thead>
            <tr>
              <th>Counter Number</th>
              <th>Pickup Date</th>
              <th>Forwarder Reference</th>
              <th>Price Table</th>
              <th>Company</th>
              <th>Service</th>
              <th>Deadline</th>
              <th>Parcels</th>
              <th>Name</th>
              <th>Address</th>
              <th>Zip</th>
              <th>City</th>
              <th>Country</th>
              <th>Volume</th>
              <th>Gross Wt.</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, rowIndex) in dropCostParcels"
              :key="'matchScannedParcel' + rowIndex"
              class="spl-match-scan-table__row">
              <td>{{ row.Counter_Number.join(", ") }}</td>
              <td>{{ moment(row.Booked_Pickup_Date).format('YYYY-MM-DD') }}</td>
              <td>{{ row.Forwarder_Reference.join(", ") }}</td>
              <td>{{ row.Price_Table_Name }}</td>
              <td>{{ row.Customer_Name }}</td>
              <td>{{ row.Service_Level_Name }}</td>
              <td>{{ moment(row.Deadline).format('YYYY-MM-DD HH:mm') }}</td>
              <td>{{ row.Number_Of_Parcels }}</td>
              <td>{{ row.Name }}</td>
              <td>{{ row.Street }}</td>
              <td>{{ row.Postal_Code }}</td>
              <td>{{ row.City }}</td>
              <td>{{ row.Country_Name }}</td>
              <td>{{ round(row.Volume, 3).toFixed(3) }}</td>
              <td>{{ round(row.Gross_Weight, 2).toFixed(2) }}</td>
              <td>{{ round(row.Cost, 2).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-if="isLoading" class="spl-load-img" />
  </div>
</template>

<script>
import Helpers from '@/helpers'
import { cloneDeep, round } from 'lodash'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import constants from '@/constants'

export default {
  name: 'DropCostReport',
  mixins: [Helpers],
  data () {
    return {
      isLoading: false,
      moment,
      round,
      constants
    }
  },
  computed: {
    ...mapState('parcelFilter', ['currentDropCostFilter']),
    ...mapState('dropCost', ['dropCostParcels'])
  },
  watch: {
    currentDropCostFilter: {
      handler: function () {
        this.isLoading = true
        // Everytime we change the parcel filter we set it to the loaded Report and execute the report again
        var parcelFilter = cloneDeep(this.currentDropCostFilter)
        this.loadDropCostReport(parcelFilter).then(() => {
          this.isLoading = false
        }).catch(() => {
          this.isLoading = false
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('dropCost', ['loadDropCostReport']),
    exportToExcel () {
      if (!this.dropCostParcels || this.dropCostParcels.lengh < 1) {
        return
      }
      var excelList = {
        Columns: [],
        Rows: []
      }

      excelList.Columns.push({ ID: 'Counter_Number', Header: 'Counter Number', Type: 'Text' })
      excelList.Columns.push({ ID: 'Booked_Pickup_Date', Header: 'Pickup Date', Type: 'DateTime' })
      excelList.Columns.push({ ID: 'Forwarder_Reference', Header: 'Forwarder Reference', Type: 'Text' })
      excelList.Columns.push({ ID: 'Price_Table_Name', Header: 'Price Table', Type: 'Text' })
      excelList.Columns.push({ ID: 'Customer_Name', Header: 'Company', Type: 'Text' })
      excelList.Columns.push({ ID: 'Service_Level_Name', Header: 'Service', Type: 'Text' })
      excelList.Columns.push({ ID: 'Deadline', Header: 'Deadline', Type: 'DateTime' })
      excelList.Columns.push({ ID: 'Number_Of_Parcels', Header: 'Parcels', Type: 'Number' })
      excelList.Columns.push({ ID: 'Name', Header: 'Name', Type: 'Text' })
      excelList.Columns.push({ ID: 'Street', Header: 'Address', Type: 'Text' })
      excelList.Columns.push({ ID: 'Postal_Code', Header: 'Zip', Type: 'Text' })
      excelList.Columns.push({ ID: 'City', Header: 'City', Type: 'Text' })
      excelList.Columns.push({ ID: 'Country_Name', Header: 'Country', Type: 'Text' })
      excelList.Columns.push({ ID: 'Volume', Header: 'Volume', Type: 'Number' })
      excelList.Columns.push({ ID: 'Gross_Weight', Header: 'Gross Wt.', Type: 'Number' })
      excelList.Columns.push({ ID: 'Cost', Header: 'Price', Type: 'Number' })

      // add the values
      for (let i = 0; i < this.dropCostParcels.length; i++) {
        var rowValues = { Value: [] }
        const parcel = this.dropCostParcels[i]
        for (let j = 0; j < excelList.Columns.length; j++) {
          const field = excelList.Columns[j]
          if (field.ID === 'Counter_Number' || field.ID === 'Forwarder_Reference') {
            rowValues.Value.push(parcel[field.ID].join(', '))
          } else {
            rowValues.Value.push(parcel[field.ID])
          }
        }
        excelList.Rows.push(rowValues)
      }
      // Call the excel download helper
      var today = moment().format('YYYY-MM-DD')
      this.getexcelDownload(excelList, `DropCostInvoice-${today}.xlsx`)
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';
  .spl-drop-cost-table {
    margin: 0 70px;
    overflow: auto;
    width: calc(100% - 138px);
    height: calc(100vh - 219px);
    &__excel {
      margin-left: 70px;
    }
    table {
      border-spacing: 0;
      table-layout: fixed;
      border: 0;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
        border: 0;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
      &--return [name='Counter Number'] {
        background-color: #fbd5d5;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 0 7px 0 6px;
        }
        position: sticky;
        background-color: $tableHeaderBackgroundColor;
        left: 0;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        z-index: 2;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {

      tr {
        background-color: $tableRowBackgroundColor;
      }

      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }

      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
      }

      td:first-child {
        border-left-width: 1px;
      }
    }

  }
</style>
